module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Mouse-6b178dc25a2d5c93447a127225aa0511.svg";